import { render, staticRenderFns } from "./SaleStatus.vue?vue&type=template&id=ca88e840&"
import script from "./SaleStatus.vue?vue&type=script&lang=js&"
export * from "./SaleStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports